<template>
  <div>
    <!-- Rename Dialog -->
    <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t('core.rename')"
      :default-cancel="false" :width="420" @close="closeDialog">
      <ul class="form-list">
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t("core.rename")}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <input class="tc-15-input-text xs" :placeholder="$t('core.file_name')" maxlength="100" v-focus
                v-model.trim="renameName" />
              <p class="form-input-help">{{$t("cos.validate.support_char_most",{num: 100})}}</p>
            </div>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t("core.path")}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <input class="tc-15-input-text xs" v-model.trim="path" />
            </div>
          </div>
        </li>
      </ul>

      <div slot="button">
        <div class="justify-grid">
          <div class="col"></div>
          <div class="col">
            <qc-button type="default" @click="renameFile" :title="$t('core.save')">{{$t('core.save')}}</qc-button>
            <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
          </div>
        </div>
      </div>

    </qc-dialog>
  </div>

</template>

<script>
import { tips, path } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    filename: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      renameName: '',
      path: '',
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },
  watch: {
    show() {
      // 弹窗打开后初始化
      if (this.show) {
        this.path = path.dirname(this.filename);
        const subLen = this.path.length > 0 ? this.path.length + 1 : 0;
        this.renameName = this.filename.substring(subLen);
      }
    },
  },
  methods: {
    // 文件重命名
    renameFile() {
      const { lang } = window;
      if (!this.renameName) {
        tips.error(lang.t('cos.validate.empty_file_name'));
        return;
      }

      let newPath = '';
      newPath = this.path
        .replace(/\/*$/, '/')
        .replace(/^\/+/, '')
        .replace(/\/{2,}/, '/');
      if (newPath === './') newPath = '';

      const oldKey = this.filename;
      const newKey = `${newPath}${this.renameName}`;
      if (newKey === oldKey) return;
      this.closeDialog();

      this.$emit('submit', newKey);
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
